import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <header class="bg-gradient-to-r from-brand-primary to-brand-accent text-white">
      <div class="container mx-auto px-4 py-6">
        <div class="flex items-center justify-between">
          <a routerLink="/" class="flex items-center gap-4 cursor-pointer hover:opacity-90 transition-opacity no-underline hover:no-underline text-white">
            <img
              src="assets/Logo.svg"
              alt="Videowand Leipzig Logo"
              class="h-12 w-auto drop-shadow"
              width="48"
              height="48"
            />
            <div>
              <p class="text-sm uppercase tracking-[0.2em] text-white/80">Videowand Leipzig</p>
              <p class="text-lg font-semibold text-white">Mobile Video Outdoor Solution</p>
            </div>
          </a>
          
          <div class="flex items-center gap-4">
            <p class="text-sm opacity-90 hidden sm:block">Outdoor LED | Event | Rental</p>
            
            @if (isLoggedIn) {
              <div class="flex items-center gap-3">
                <span class="text-sm opacity-90">{{ username }}</span>
                <button (click)="logout()" class="bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg text-sm font-medium transition-colors">
                  Logout
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </header>
  `,
  styles: []
})
export class HeaderComponent implements OnInit {
  isLoggedIn = false;
  username?: string;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.isLoggedIn = this.authService.isLoggedIn();
    if (this.isLoggedIn) {
      this.username = this.authService.getUsername();
    }
  }

  login(): void {
    this.authService.login();
  }

  logout(): void {
    this.authService.logout();
  }
}
